import { APIHeader } from "../config/ApiHeaders";
import { APIPaths } from "../config/ApiPaths";
import { APIResult } from "../config/ApiResults";

async function callAPI(body, target, defaultReturn, method = "POST") {
  const requestOptions = {
    method: method,
    headers: {
      "Content-Type": APIHeader.ContentType,
      Key: APIHeader.apikey,
    },
  };

  if (method === "POST") {
    requestOptions.body = JSON.stringify(body);
  }

  var proceed = true;

  Object.values(body).forEach(param => {
    if (param === null || param === undefined) {
      proceed = false;
    }
  });

  if (proceed) {
    await new Promise(resolve => setTimeout(resolve, 500));
    return await fetch(target, requestOptions)
      .then(response => {
        // if (response.status === 401) {
        //   localStorage.clear();
        //   EventBus.dispatch("changeURL", "/login?error=1");
        // }
        return response.json();
      })
      .then(responseData => {
        // try {
        //   if (responseData.status === APIResult.INVALID_SESSION) {
        //     window.location.reload();
        //     console.log("Invalid session");
        //   } else if (responseData.status === APIResult.INVALID) {
        //     console.log("Invalid");
        //     localStorage.clear();
        //     window.location.reload();
        //   }
        // } catch (e) {
        //   debugPrint(e);
        // }
        return responseData;
      })
      .catch(error => {
        console.warn(error);
        return defaultReturn;
      });
  } else {
    return defaultReturn;
  }
}

export async function getMap() {
  var body = {};

  var target = APIPaths.endPoint + APIPaths.getMap;

  return callAPI(
    body,
    target,
    {
      status: APIResult.INVALID,
      status_message: "-",
      result: [],
    },
    "GET"
  );
}
